/* eslint-disable */
export const show = { notMatched: n => n.hidden = true };
export const hide = { matched: n => n.hidden = true };
export const highlight = { matched: n => n.hl = true };
export const focus = { matched: n => n.focus = true };
